// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Button_wrap__2JIGc","loading":"Button_loading__2nORI","hidden":"Button_hidden__3ngR4"};